import { c as _c } from "react/compiler-runtime";
import React from "react";
import style from "./Spinner.module.scss";
export const Spinner: React.FC<{
  className?: string;
}> = t0 => {
  const $ = _c(2);
  const {
    className
  } = t0;
  const t1 = style["lds-dual-ring"] + " " + className;
  let t2;
  if ($[0] !== t1) {
    t2 = <div className={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};